/* 🤖 this file was generated by script */
export const wiconTagsPlus = {
  name: 'tags_plus',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.04 5.99v4.24m0 0v4.24m0-4.24H9.8m4.24 0h4.24m-6.83 4.75l-1.38 1.37c-.29.29-.79.3-1.08 0L2.64 10V3.43h6.57l2.38 2.38"/><circle cx="6.15" cy="6.92" r=".69" fill="currentColor"/></svg>`,
};
